// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7474f966","239":"e12b6a6c","455":"d6401021"}[chunkId] + ".chunk.js";
};